import { useQuery } from "@tanstack/react-query";
import { USER_API } from "config";
import { normalizeId } from "utils";
import { budgetKeys } from "queries";
import { useAxios } from "../useAxios";
import { useProjectAuth } from "../project/useProjectAuth";
import { Permissions } from "utils/permissions/permissionConstants";
import { BudgetCategory } from "components/dashboard/body/projects/panels/budget/types";

export interface BudgetTemplate {
  name: string;
  data: BudgetCategory[];
}

interface UseBudgetTemplatesParams {
  projectId: string | number;
  documentId: string | number;
  enabled?: boolean;
}

export const useBudgetTemplates = ({
  projectId,
  documentId,
  enabled = true,
}: UseBudgetTemplatesParams) => {
  const axios = useAxios({ allResponse: false });
  const pid = normalizeId(projectId);
  const did = normalizeId(documentId);
  const { canProject, isLoading: isAuthLoading } = useProjectAuth(pid);

  const canReadTemplates = canProject(Permissions.PROJECT_READ);

  return useQuery<BudgetTemplate[]>({
    queryKey: budgetKeys.templates(pid, did),
    queryFn: async () => {
      const response = await axios.get<BudgetTemplate[]>(USER_API.getBudgetTemplates(pid, did));
      const templates = Array.isArray(response)
        ? response
        : (response as { data?: BudgetTemplate[] }).data;
      return templates ?? [];
    },
    enabled: enabled && Boolean(pid) && Boolean(did) && !isAuthLoading && canReadTemplates,
    staleTime: Infinity,
  });
};
